import $ from "jquery";

// describe and create object
class Filter {
  constructor() {
    this.filter_events = $(".overview .filter .events");
    this.filter_news = $(".overview .filter .news");
    this.filter_projects = $(".overview .filter .projects");
    this.events();
  }

  // events for triggering function
  events() {
    this.filter_events.on("click", this.toogle_events);
    this.filter_news.on("click", this.toogle_news);
    this.filter_projects.on("click", this.toogle_projects);
  }

  // method/function

  toogle_events() {
    $(".overview")
      .toggleClass("events_active")
      .removeClass("news_active projects_active");
    event.preventDefault();
  }
  toogle_news() {
    $(".overview")
      .toggleClass("news_active")
      .removeClass("events_active projects_active");
    event.preventDefault();
  }
  toogle_projects() {
    $(".overview")
      .toggleClass("projects_active")
      .removeClass("events_active news_active");
    event.preventDefault();
  }
}

export default Filter;
